<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Notificaciones</div>
        <span class="grey--text text--lighten-2">Relación de las últimas notificaciones enviadas</span>
      </div>
    </v-card-title>

    <div class="pa-2">
      <v-list two-line>
        <template v-for="(notificacion, i) in notificaciones">
          <v-list-tile 
            :key="notificacion.idnotificacion"
            @click="verNotificacion(i)">

            <v-list-tile-action>
              <v-badge overlap color="red">
                <v-icon large v-if="notificacion.ts_lectura">notifications</v-icon>
                <v-icon large v-if="!notificacion.ts_lectura">notifications_active</v-icon>
              </v-badge>
            </v-list-tile-action>
            
            <v-list-tile-content>
              <v-list-tile-title>{{ notificacion.titulo }}</v-list-tile-title>            
              
              <v-list-tile-sub-title>
                <!-- <span class='text--primary'>{{ notificacion.mensaje }}</span>  -->
                {{ notificacion.ts | moment("from")}}
              </v-list-tile-sub-title>

              
            </v-list-tile-content>

          </v-list-tile>
        </template>
      </v-list>
    </div>
  </v-card>
</template>

<style>
</style>

<script>
  import { mapState } from 'vuex'
  import { NOTIFICACIONES_REQUEST, NOTIFICACION_READ } from '../store/actions/notificaciones';

  export default {
    name: 'BrwNotificaciones',
    
    data: function () {
      return {}
    },

    created: function () {
      this.cargarNotificaciones()
    },

    watch: {
      '$route': 'cargarNotificaciones'
    },

    methods: {
      cargarNotificaciones() {
        this.$store.dispatch(NOTIFICACIONES_REQUEST)
      },
      verNotificacion(idnotificacion) {
        this.$store.dispatch(NOTIFICACION_READ, idnotificacion)
      }
    },
    computed: {
      ...mapState({
        notificaciones: state => state.notificaciones.notificaciones
      })
    }
  }
</script>